export enum SignalMutationStatus {
    SOMATIC = 'Somatic',
    GERMLINE = 'Germline',
    BENIGN_GERMLINE = 'Germline - Benign/VUS',
    PATHOGENIC_GERMLINE = 'Germline - Pathogenic',
    BIALLELIC_PATHOGENIC_GERMLINE = 'Germline - Biallelic Pathogenic',
    UNKNOWN = 'Unknown',
}
